package one.healthium.settings.ui.menu

import androidx.compose.runtime.Immutable
import one.healthium.settings.domain.SettingsMenuModel

@Immutable
data class SettingsMenuUiState(
    val loading: Boolean = false,
    val menuId: String? = null,
    val menu: List<SettingsMenuModel>? = null,
)
